var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveOptions
    ? _c(
        "div",
        { staticClass: "input input--select", class: _vm.inputClass },
        [
          _vm.labelText
            ? _c(
                "label",
                { class: _vm.labelClass, attrs: { for: "select" + _vm._uid } },
                [_vm._v(_vm._s(_vm.labelText))]
              )
            : _vm._e(),
          _c("input", {
            attrs: { type: "hidden", name: _vm.selectName },
            domProps: {
              value: _vm.selectedValue
                ? _vm.selectedValue.value
                : _vm.options[0].value,
            },
          }),
          !_vm.showNativeSelect
            ? _c("v-select", {
                ref: "vSelect",
                attrs: {
                  options: _vm.optionSet,
                  disabled: _vm.disabled,
                  clearable: false,
                  value: _vm.selectedValue,
                  placeholder: _vm.defaultOption,
                  searchable: false,
                  "select-on-tab": true,
                  components: { OpenIndicator: _vm.OpenIndicator },
                },
                on: { input: _vm.update },
              })
            : _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentValue,
                      expression: "currentValue",
                    },
                  ],
                  attrs: { disabled: _vm.disabled, id: "select" + _vm._uid },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentValue = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  !_vm.required
                    ? _c("option", { domProps: { value: null } }, [
                        _vm._v(_vm._s(_vm.defaultOption)),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.options, function (option) {
                    return _c(
                      "option",
                      { key: option.value, domProps: { value: option.value } },
                      [_vm._v(_vm._s(option.label))]
                    )
                  }),
                ],
                2
              ),
          _vm.showNativeSelect
            ? _c("icon", { attrs: { name: "chevron-down", size: "16px" } })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }